import {createContext} from "react";
import {registryFactory} from "@common/ui-components/registry/registry-factory";

const {Provider, Consumer} = createContext();

export const PopupProvider = Provider;
export const PopupConsumer = Consumer;

export const popupRegistry = registryFactory({className: "dropdown-registry", Provider: PopupProvider});
